import React from 'react';
import EditButton from '../../../components/ui/EditButton';
import { isEditableTeamTag } from '../utils/learnToRow';

export default function TagsCard({ tags = [], onEdit, isAdmin}) {
  const regularTags = tags.filter(tag => isEditableTeamTag(tag));
  const ageRules = tags.filter(tag => tag.type === 'ageRule');

  const getAgeRuleTagNames = (rule) => {
    if (Array.isArray(rule?.tagNames)) {
      return rule.tagNames.filter((name) => typeof name === 'string' && name.trim() !== '');
    }
    if (typeof rule?.tagName === 'string' && rule.tagName.trim() !== '') {
      return [rule.tagName];
    }
    return [];
  };

  const grouped = regularTags.reduce((acc, tag) => {
    const cat = tag.category || 'Uncategorised';
    acc[cat] = acc[cat] || [];
    acc[cat].push(tag);
    return acc;
  }, {});

  return (
    <div className="team-card">
      <div className="card-header-with-icon">
        <span className="card-title">Manage Tags</span>
        {isAdmin && (<EditButton section="tags" onEdit={onEdit} />)}
      </div>
      <div className="card-body">
        {tags.length === 0 ? (
          <p className="text-muted">No tags added yet.</p>
        ) : (
          <>
            {Object.entries(grouped).map(([category, tagsInCategory]) => (
              <div key={category} className="tag-category-block">
                <h4 className="tag-category-heading">{category}</h4>
                <div className="tags-list">
                  {tagsInCategory.map(tag => {
                    const tagName = typeof tag.name === 'string' ? tag.name : 'Unnamed Tag';

                    return (
                      <span key={tagName} className="tag-chip">
                        {tagName}{tag.requiredForMembers === true ? ' (required)' : ''}
                      </span>
                    );
                  })}
                </div>
              </div>
            ))}

            {ageRules.length > 0 && (
              <div className="tag-category-block">
                <h4 className="tag-category-heading">Age Tag Rules</h4>
                {ageRules.map((rule, index) => {
                  const tagNames = getAgeRuleTagNames(rule);
                  return (
                    <p key={`${rule.rule}-${rule.age}-${rule.effectiveDate?.day}-${rule.effectiveDate?.month}-${index}`}>
                      If a member is <strong>{rule.rule} {rule.age}</strong> years old on{' '}
                      <strong>{rule.effectiveDate?.day} {rule.effectiveDate?.month}</strong>,
                      assign {tagNames.length > 1 ? 'the tags ' : 'the tag '}
                      {tagNames.length > 0 ? (
                        <>
                          {tagNames.map((name) => (
                            <span key={name} className="tag-chip" style={{ marginRight: 6 }}>
                              {name}
                            </span>
                          ))}
                        </>
                      ) : (
                        <span className="text-muted">no tag set</span>
                      )}
                      .
                    </p>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
